import { FC } from 'react';
import style from './TenantSwitchBanner.module.css';
import { SelectedTenant } from '@/config/initialState';

interface TenantSwitchBannerProps {
  selectedTenant: SelectedTenant;
}

export const TenantSwitchBanner: FC<TenantSwitchBannerProps> = ({
  selectedTenant,
}) => {
  if (!selectedTenant) {
    return null;
  }

  return (
    <div className={style['banner']}>
      <i className={`icon-storing-entering-shop ${style['icon']}`} />
      <span className={style['text']}>
        ショッピング中:{' '}
        <span className={style['tenant-name']}>
          {selectedTenant.affiliate_name}
        </span>
      </span>
    </div>
  );
};
